export default __webpack_public_path__ + "img/63ee8fed1bd468fb2092b68b3034eba2.svg";